import React = require('react');
import { FaSpinner } from 'react-icons/fa';
import { Button } from 'react-bootstrap';
import { useState } from 'react';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { actions as authActions, IAuthActions } from '../../../../../services/auth/reducer';
import { actions as quoteActions } from '../../../../../services/quote/reducer';
import { IQuoteActions } from '../../../../../services/quote/models';

interface INewQuoteButton {
  actions: {
    auth: IAuthActions;
    quote: IQuoteActions;
  }
  isLink?: boolean;
  linkText?: string;
  fullWidth?: boolean;
}

const NewQuoteButton = ({ actions, fullWidth = false, isLink = false, linkText = '' }: INewQuoteButton) => {

  const [isRedirectToNewQuote, setIsRedirectToNewQuote] = useState(false);

  const handleNewQuote = () => {
    setIsRedirectToNewQuote(true)
    Promise.resolve(actions.auth.initQuoteFromCustomer()).then(() => {
      setIsRedirectToNewQuote(false)
    })
  }

  if (isLink && linkText) {
    return (
      <a onClick={handleNewQuote} style={{cursor: 'pointer', textDecoration: 'underline'}}>{linkText}</a>
    )
  }

  return (
    <Button
      bsStyle={'primary'}
      className="new-quote-button"
      onClick={handleNewQuote}
      block={fullWidth}
      disabled={isRedirectToNewQuote}>
      {isRedirectToNewQuote && (<FaSpinner className="fa-spin"/>)}{' '}
      {'GET A NEW QUOTE'}
    </Button>
  )
}

export default flow([
  connect(
    (state: IStore) => {
      return {
        auth: state.auth,
        quote: state.quote,
      };
    },
    (dispatch) => ({
      actions: {
        auth: bindActionCreators({ ...authActions }, dispatch),
        quote: bindActionCreators({ ...quoteActions }, dispatch),
      },
    }),
  ),
])(NewQuoteButton);
